/*
 * JOINMELI - Sepet hediyesi otomatik ekleme
 * Esik: 5.000 TL  |  Hediye: Bacak Masaj Aleti - Pembe
 *
 * - Esik asilinca hediye eklenir, altina dusunce cikarilir
 * - Musteri hediyeyi kaldirirsa o oturumda tekrar eklenmez
 * - Odemeye gecmeden once son kontrol yapilir
 */
(function () {
  if (window.__meliGiftInit) return;
  window.__meliGiftInit = true;

  var GIFT_VARIANT_ID = 45873142431788;
  var THRESHOLD = 500000; // kurus
  var OPT_OUT_KEY = 'meliGiftDeclined';

  var busy = false;
  var lastHadGift = null;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function declined() {
    try { return sessionStorage.getItem(OPT_OUT_KEY) === '1'; } catch (e) { return false; }
  }
  function setDeclined() { try { sessionStorage.setItem(OPT_OUT_KEY, '1'); } catch (e) {} }
  function clearDeclined() { try { sessionStorage.removeItem(OPT_OUT_KEY); } catch (e) {} }

  function getCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function giftLine(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === GIFT_VARIANT_ID) {
        return { item: cart.items[i], line: i + 1 };
      }
    }
    return null;
  }

  function qualifyingTotal(cart, gift) {
    var t = cart.items_subtotal_price;
    if (gift) t -= gift.item.final_line_price;
    return t;
  }

  function changeLine(line, quantity) {
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  function addGift() {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: GIFT_VARIANT_ID, quantity: 1 }] })
    }).then(function (r) { return r.json(); });
  }

  function repaint() {
    // Sepet arayuzunu tazele
    try {
      if (window.FoxThemeEvents && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
        return getCart().then(function (c) {
          window.FoxThemeEvents.emit(window.PUB_SUB_EVENTS.cartUpdate, c);
          window.location.reload();
        });
      }
    } catch (e) {}
    window.location.reload();
    return Promise.resolve();
  }

  /* Ana esitleme. changed=true donerse arayuz tazelenmeli. */
  function evaluate() {
    return getCart().then(function (cart) {
      var gift = giftLine(cart);
      var total = qualifyingTotal(cart, gift);
      var qualifies = total >= THRESHOLD;

      // Hediye vardi, artik yok, hala esik uzerinde -> musteri kaldirmis
      if (lastHadGift === true && !gift && qualifies) setDeclined();
      lastHadGift = !!gift;

      if (cart.item_count === 0) {
        clearDeclined();
        lastHadGift = false;
        return false;
      }

      if (!qualifies) {
        clearDeclined();
        if (gift) {
          lastHadGift = false;
          return changeLine(gift.line, 0).then(function () { return true; });
        }
        return false;
      }

      if (declined()) return false;

      if (!gift) {
        return addGift().then(function () { lastHadGift = true; return true; });
      }
      if (gift.item.quantity > 1) {
        return changeLine(gift.line, 1).then(function () { return true; });
      }
      return false;
    });
  }

  function sync() {
    if (busy) return Promise.resolve(false);
    busy = true;
    return evaluate()
      .then(function (changed) {
        if (changed) return repaint().then(function () { return true; });
        return false;
      })
      .catch(function (e) { console.error('meli-gift', e); return false; })
      .finally(function () { setTimeout(function () { busy = false; }, 500); });
  }

  /* --- Sepet cagrilarini yakala (tema hangi yontemi kullanirsa kullansin) --- */
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?/i;

  var origFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    if (url && url.url) url = url.url;
    var isCartWrite = typeof url === 'string' && CART_WRITE.test(url) && url.indexOf('meli-skip') === -1;
    var p = origFetch.apply(this, arguments);
    if (isCartWrite) {
      p.then(function () { setTimeout(sync, 250); }).catch(function () {});
    }
    return p;
  };

  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__meliCartWrite = typeof url === 'string' && CART_WRITE.test(url);
    return origOpen.apply(this, arguments);
  };
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this.__meliCartWrite) {
      this.addEventListener('load', function () { setTimeout(sync, 250); });
    }
    return origSend.apply(this, arguments);
  };

  /* --- Odemeye gecmeden once son kontrol --- */
  function guardCheckout() {
    document.addEventListener('click', function (e) {
      var el = e.target.closest(
        'button[name="checkout"], [name="checkout"], a[href*="/checkout"], .f-cart__checkout, .cart__checkout-button'
      );
      if (!el || el.__meliChecked) return;

      e.preventDefault();
      e.stopPropagation();

      evaluate()
        .then(function (changed) {
          if (changed) return repaint();
          el.__meliChecked = true;
          el.click();
        })
        .catch(function () {
          el.__meliChecked = true;
          el.click();
        });
    }, true);
  }

  function start() {
    getCart().then(function (cart) {
      lastHadGift = !!giftLine(cart);
      sync();
    });
    guardCheckout();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
